import { MenuItem, TextField } from '@mui/material';
import React from 'react'
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCurrentTripForm, updateAge } from '../../../redux/features/tripFormSlice';

const AgeSelection = () => {
    const tripStateData = useSelector(fetchCurrentTripForm)
    const dispatch = useDispatch()
    
    const ages = [
        {
            value: "1 years",
            label: "1 years",
        },
        {
            value: "2 years",
            label: "2 years",
        },
        {
            value: "3 years",
            label: "3 years",
        },
        {
            value: "4 years",
            label: "4 years",
        },
        {
            value: "5 years",
            label: "5 years",
        },
        {
            value: "6 years",
            label: "6 years",
        },
        {
            value: "7 years",
            label: "7 years",
        },
        {
            value: "8 years",
            label: "8 years",
        },
        {
            value: "9 years",
            label: "9 years",
        },
        {
            value: "10 years",
            label: "10 years",
        },
        {
            value: "11 years",
            label: "11 years",
        },
        {
            value: "12 years",
            label: "12 years",
        },
        {
            value: "13 years",
            label: "13 years",
        },
        {
            value: "14 years",
            label: "14 years",
        },
        {
            value: "15 years",
            label: "15 years",
        },
        {
            value: "16 years",
            label: "16 years",
        },
        {
            value: "17 years",
            label: "17 years",
        },
    ];

    const handleAgeChange = (onChangeValue, i) => {
        const age = {
            id : i,
            value : onChangeValue.target.value
        }
        console.log(age,'onChangeValue')
        dispatch(updateAge(age));
    };
    const style = {    
        "& .MuiOutlinedInput-root": {
                width: "187px",
                background: "#F1F3F9",
                height: "45px",
                borderRadius: "8px",
                borderColor: "#E7E9F2",
                "&.Mui-focused fieldset": {
                    borderColor: "#4DC1BA",
            },
                "&:hover fieldset": {
                borderColor: "#E7E9F2",
            },
            }
    }
    return (
        tripStateData?.ageRows?.map((ageRow, i) => {
            return (
                <div style={{ display: "flex", margin: "10px",gap: "30px", marginBottom: "40px" }}>
                    <p style={{width: "30%"}}>Child {ageRow.id}</p>

                    <TextField sx={style} 
                        id="outlined-select-state"
                        select
                        // label="age"
                        fullWidth
                        value={ageRow?.value? ageRow.value : ''}
                        onChange={(e) => handleAgeChange(e, ageRow.id)}
                    >
                        {ages.map((option) => (
                            <MenuItem key={option.value} value={option.value} >
                                {option.label}
                            </MenuItem>
                        ))}
                    </TextField>


                </div>
            );
        }
        )

    )
}

export default AgeSelection